module.exports = __webpack_public_path__ + "img/Frame 751.bd608085.png";